import { Button } from "primereact/button";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const Footer = () => {
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);
  return (
    <>
      <div className="footer">
        <div className="footer-container">
          <div className="footer-section">
            <h4>NexaWage Payroll</h4>
            <p>
              Smart payroll & compliance platform for Canadian businesses.
              Simplify payroll today with NexaWage Payroll.
            </p>
          </div>
          <div className="footer-section">
            <h4>Quick Links</h4>
            <div className="links-navigate">
              <ul>
                <li>
                  <a onClick={() => navigate("/")}>About Us</a>
                </li>
                <li>
                  <a onClick={() => navigate("/terms-condition")}>
                    Terms & Conditions
                  </a>
                </li>
                <li>
                  <a onClick={() => navigate("/privacy-policy")}>
                    Privacy Policy
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div className="footer-section">
            <h4>Contact</h4>
            <p>Based in Canada</p>
            <p>Phone: +1 844-200-5055</p>
            <p>
              Email:{" "}
              <a href="mailto:payroll@nexawage.com" target="_blank">
                payroll@nexawage.com
              </a>
            </p>
          </div>
          <div className="footer-section">
            <h4>Stay Updated</h4>
            <Button
              label="Login"
              className="p-button-rounded p-button-lg"
              style={{
                padding: "5px 16px",
                borderRadius: "10px",
                background: "#fff",
                color: "#111",
                fontSize: "14px",
                // border:"2px solid black"
              }}
              onClick={() => navigate("/login")}
            />
          </div>
        </div>
        <div className="footer-bottom">
          <p>© {new Date().getFullYear()} NexaWage Payroll. All rights reserved.</p>
        </div>
      </div>
    </>
  );
};

export default Footer;
